import React, {useEffect, useRef, useState} from "react";
import {Button, Container, Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import MiniLoader from "../components/MiniLoader";
import axios from "axios";
import FeatherIcon from "feather-icons-react";

const SecurityCode = () => {
    const { t } = useTranslation();
    document.title=t("Security Code")
    const history = useHistory();

    const [loader, setLoader] = useState(false)
    const [error, setError] = useState()

    let sendSecurityCode = async (e) => {
        e.preventDefault()
        setLoader(true)
        if (!localStorage.getItem('emailVerify')) {
            history.push('/verify-email');
            toast(t("Please, enter valid email"), {type: "error"})
        }
        else {
            try {
                let email = localStorage.getItem('emailVerify')
                let code = e.target.code1.value + e.target.code2.value + e.target.code3.value + e.target.code4.value + e.target.code5.value + e.target.code6.value
                let response = await axios.post('/api/v1.0/users/security-code/', {
                    'email': email,
                    'security_code': code
                })
                localStorage.removeItem('emailVerify')
                localStorage.setItem('emailVerifyToken', response.data.token)
                history.push('/recovery-password')
                toast(t("Now you can create new password"), {type: "success"})
            }
            catch (error) {
                if (error.response.status === 500) {
                    history.push('/500')
                }
                if('error' in error.response.data)
                    setError(error.response.data.error)
                else
                toast(t("Incorrect security code"), {type: "error"})
                setTimeout(() => {setLoader(false)}, 200)
            }
        }
    }

    const [formState, setFormState] = useState({
        code1: "",
        code2: "",
        code3: "",
        code4: "",
        code5: "",
        code6: "",
    });

    const code1Ref = useRef(null);
    const code2Ref = useRef(null);
    const code3Ref = useRef(null);
    const code4Ref = useRef(null);
    const code5Ref = useRef(null);
    const code6Ref = useRef(null);

    useEffect(() => {
        if(!loader)
            code1Ref.current.focus();
    }, []);

    const handleInputChange = function (e) {
        if (e.target.value !== "")
        {
            if (e.target.name === "code1")
                code2Ref.current.focus();
            else if (e.target.name === "code2")
                code3Ref.current.focus();
            else if (e.target.name === "code3")
                code4Ref.current.focus();
            else if (e.target.name === "code4")
                code5Ref.current.focus();
            else if (e.target.name === "code5")
                code6Ref.current.focus();
        }

        setFormState({
            ...formState,
            [e.target.name]: e.target.value,
        });
    };

    return (
            <div className="auth-card">
                <h2>{t("Security Code")}</h2>
                <h4>{t("Type your 6 digit security code")}</h4>
                    <Form onSubmit={sendSecurityCode} className={loader ? "hide" : ""}>
                        <div className="security_code">

                            {/*{*/}
                            {/*    Array.from(*/}
                            {/*        { length: 6 },*/}
                            {/*        (_, i) => (*/}
                            {/*            <Form.Group className="mb-3" controlId={`formSecurityCode${i+1}`}>*/}
                            {/*                <Form.Control*/}
                            {/*                    type="number"*/}
                            {/*                    size="1"*/}
                            {/*                    maxLength="1"*/}
                            {/*                    minLength="1"*/}
                            {/*                    onInput= {(event)=> event.target.value.length > 1 ?*/}
                            {/*                        event.target.value =*/}
                            {/*                            event.target.value.slice(0, 1)*/}
                            {/*                        :*/}
                            {/*                        event.target.value*/}
                            {/*                    }*/}
                            {/*                    required*/}
                            {/*                    name={`code${i+1}`}*/}
                            {/*                    onChange={handleInputChange}*/}
                            {/*                    className={ formState.code(i+1) ? "border-color" : ""}*/}
                            {/*                    ref={code6Ref}*/}
                            {/*                />*/}
                            {/*            </Form.Group>*/}
                            {/*        ))*/}
                            {/*}*/}

                            <Form.Group className="mb-3" controlId="formSecurityCode1">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code1"
                                    onChange={handleInputChange}
                                    className={ formState.code1 ? "border-color" : ""}
                                    ref={code1Ref}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formSecurityCode2">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code2"
                                    onChange={handleInputChange}
                                    className={ formState.code2 ? "border-color" : ""}
                                    ref={code2Ref}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formSecurityCode3">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code3"
                                    onChange={handleInputChange}
                                    className={ formState.code3 ? "border-color" : ""}
                                    ref={code3Ref}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formSecurityCode4">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code4"
                                    onChange={handleInputChange}
                                    className={ formState.code4 ? "border-color" : ""}
                                    ref={code4Ref}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formSecurityCode5">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code5"
                                    onChange={handleInputChange}
                                    className={ formState.code5 ? "border-color" : ""}
                                    ref={code5Ref}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formSecurityCode6">
                                <Form.Control
                                    type="number"
                                    size="1"
                                    maxLength="1"
                                    minLength="1"
                                    onInput= {(event)=> event.target.value.length > 1 ?
                                        event.target.value =
                                            event.target.value.slice(0, 1)
                                        :
                                        event.target.value
                                    }
                                    required
                                    name="code6"
                                    onChange={handleInputChange}
                                    className={ formState.code6 ? "border-color" : ""}
                                    ref={code6Ref}
                                />
                            </Form.Group>
                        </div>
                        <div id="match-text" className={error ? "active" : "hide"}>
                            <Form.Text className={`text-muted alarm`}>
                                <FeatherIcon icon="alert-circle" /> {t(error)}
                            </Form.Text><br/>
                        </div>
                        <Button variant="green" type="submit">
                            {t("Submit")}
                        </Button>
                    </Form>
                    { !loader ? "" : (
                        <div className="center-block">
                            <center>
                                <MiniLoader />
                            </center>
                        </div>)
                    }

            </div>
    )
}

export default SecurityCode
